<div class="m-1 p-0 w-10 position-relative" appPreventSwipeBack [ngStyle]="{'cursor': isLoadingCursor == true ? 'progress' : 'default'}">
  @if (isLoadingLabelVisible == true) {
    <div class="loading-label">
      Please wait, generating content...
    </div>
  }
  @if (userId != undefined && userId != '') {
    <app-inlinetutorial [title]="'This is your creative board.'" [body]="'Collaborate with your team to brainstorm new ideas or simply take notes. You can add cards, images, links, and tasks; connect them with arrows, or draw freely.<br/>A special feature, frames, allows you to select multiple objects, such as tasks or pieces of knowledge, to create mind maps, status reports, opportunity solution trees, and more.'" [key]="'canvas'" [userId]="userId"></app-inlinetutorial>
  }
  @if (showChatbotPopup == true) {
    <app-chatbotpopup [userId]="userId" [initialMessage]="messageToChatbot" [isChatbotExpanded]="true" (closeChatbotPopupEvent)="onCloseChatbotPopup()"></app-chatbotpopup>
}

  <!-- collapse/expand menu plus right -->
  <div class="context-menu p-1" id="context-menu-collapse-expand" [ngClass]="{'context-menu-hidden': isContextMenuCollapseExpandVisible == false}">
    <div class=" p-0">
      <div class="transparent-btn pt-1 pe-1 ps-1" (click)="collapseExpand()">
        @if (!isSelectedShapeExpanded) {
          <span class="fluent--triangle-down-12-filled" data-bs-toggle="tooltip" data-bs-placement="top" title="Expand" data-bs-delay="{show: 1000}"></span>
        } @else {
          <span class="fluent--triangle-right-12-filled" data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" data-bs-delay="{show: 1000}"></span>
        }
      </div>
    </div>
  </div>

  <!-- comment list -->
  <div class="commentlist" id="context-menu-commentlist" [ngClass]="{'context-menu-hidden': isContextMenuCommentlistVisible == false}">
    <div class="context-menu-container">
      <div class="transparent-btn pt-1 pe-1" (click)="startDrawingArrow()" data-bs-toggle="tooltip" data-bs-placement="top" title="Draw connector" data-bs-delay="{show: 1000}">
        <span class="tabler--arrow-guide"></span>
      </div>
      <div class="transparent-btn pt-1 pe-1 ps-1" (click)="addBoxWithArrow(selectedShapeKey)" data-bs-toggle="tooltip" data-bs-placement="top" title="Draw connected box" data-bs-delay="{show: 1000}">
        <span class="lucide--rectangle-horizontal"></span>
      </div>
      <div class="transparent-btn pt-1 pe-1 ps-1" (click)="addBoxWithArrow('diamond')" data-bs-toggle="tooltip" data-bs-placement="top" title="Draw connected diamond" data-bs-delay="{show: 1000}">
        <span class="lucide--diamond"></span>
      </div>
      <div class="transparent-btn pt-1 pe-1 ps-1" (click)="addBoxWithArrow('circle')" data-bs-toggle="tooltip" data-bs-placement="top" title="Draw connected circle" data-bs-delay="{show: 1000}">
        <span class="lucide--circle"></span>
      </div>
      @if (selectedShapeKey.startsWith('postit')) {
        <div class="transparent-btn pt-1 ps-1" (click)="convertPostitToTask()" data-bs-toggle="tooltip" data-bs-placement="top" title="Convert card to task in project" data-bs-delay="{show: 1000}">
          <span class="mdi--list-box-outline"></span>
        </div>
      }
    </div>
    <app-commentlist [isReadOnly]="false" [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [userEmail]="userEmail" [userName]="userName" [userImageURL]="userImageURL" [contentKey]="canvasKey" [projectName]="projectName" [canvasObjectKey]="selectedShapeKey" [canvasObjectType]="friendlyNameObjectType" (onAddComment)="onAddComment([$event])" (areCanvasEventsSuspended)="onCanvasEventsSuspended($event)" (onCommentListExpanded)="onCommentListExpanded($event)"></app-commentlist>
    
  </div>

  <!-- minimap -->
  <div id="minimap" class="minimap pointer" [ngClass]="{'minimap-hidden': !isMinimapVisible}">
  </div>

  <!-- status report -->
  <div id="status-report" class="status-report p-1 status-report-container" [ngClass]="{'context-menu-hidden': isStatusReportVisible == false}" >
    <div class="status-report-title-container m-1">
      <div class="status-report-title">
        Status raport of selected tasks
      </div>
      <button class="btn my-btn noborder" (click)="closeStatusReport()">
        <span class="mdi--close"></span>
      </button>
    </div>
    @if (progressPoints.length > 0) {
      <div class="status-report-progress-hill">
        <app-progresshill [progressPoints]="progressPoints" [isReadOnly]="true" (progressHillUpdated)="onProgressHillUpdated($event)"></app-progresshill>
      </div>
    }
    <div class="status-report-content m-1" [innerHTML]="statusReportContent"></div>
  </div>
  
  <!-- context menu frame -->
    <div class="context-menu shadow-menu" id="context-menu-frame" [ngClass]="{'context-menu-hidden': isContextMenuFrameVisible == false}">
      <div class="context-menu-container-column">
        <button class="btn my-btn" (click)="createMindMap()" data-bs-toggle="tooltip" data-bs-placement="top" title="Generate mind map based on selected content" data-bs-delay="{show: 1000}">
          <span class="mingcute--mind-map-line"></span>
        </button>
        <button class="btn my-btn" (click)="createOpportunitySolutionTree()" data-bs-toggle="tooltip" data-bs-placement="top" title="Generate opportunity solution tree based on selected content" data-bs-delay="{show: 1000}">
          <span class="mdi--family-tree"></span>
        </button>
        <button class="btn my-btn" (click)="createTasks()" data-bs-toggle="tooltip" data-bs-placement="top" title="Generate task list based on selected content" data-bs-delay="{show: 1000}">
          <span class="lets-icons--subttasks-alt"></span>
        </button>
        <button class="btn my-btn" (click)="createStatusReport()" data-bs-toggle="tooltip" data-bs-placement="top" title="Generate status report based on selected tasks" data-bs-delay="{show: 1000}">
          <span class="mdi--report-timeline"></span>
        </button>
      </div>
    </div>


    <div id="container" [ngStyle]="{'cursor': isLoadingCursor == true ? 'progress' : 'default'}"></div>


  @if (isColorPalleteVisible && isReadOnly == false) {
    <color-circle [color]="pickedColor" [colors]="colors" (onChangeComplete)="colorChangeComplete($event)" class="color-pallete"></color-circle>
  }
  <div class="toolbar" id="toolbar">
    <div class="shift-info">
      Press Shift to move or delete connected objects. Ctrl/CMD+C to copy, Ctrl/CMD+V to paste.
    </div>
    <div class="button-scroll-container">
    <div class="d-flex flex-row">
      @if (isProductlyMode == true) {
        <button class="btn my-btn" (click)="addPostitCentrally(boxWidth, boxHeight*2, '', pickedColor, isProductlyMode)" data-bs-toggle="tooltip" data-bs-placement="top" title="Switch to prodely mode" data-bs-delay="{show: 1000}">
          <span class="fluent--note-pin-20-regular"></span>
        </button>
      } @else {
        <div class="btn-group m-1">
          @if (isPointerEnabled) {
            <button class="btn my-btn" (click)="handleSelectionRectanglePointer(false)" data-bs-toggle="tooltip" data-bs-placement="top" title="Switch to canvas drag mode" data-bs-delay="{show: 1000}">
              <span class="si--move-fill"></span>
            </button>
            } @else {
            <button class="btn my-btn" (click)="handleSelectionRectanglePointer(true)" data-bs-toggle="tooltip" data-bs-placement="top" title="Switch to object selection mode" data-bs-delay="{show: 1000}">
              <span class="mdi--button-pointer"></span>
            </button>
            }
          <button class="btn my-btn" [ngClass]="{'button-on': isFreeHandDrawingEnabled}" (click)="switchFreeHandDrawing()" data-bs-toggle="tooltip" data-bs-placement="top" title="Free hand drawing" data-bs-delay="{show: 1000}">
            <span class="mdi--freehand-line"></span>
          </button>
          <button (click)="setColorClicked()" type="button" class="btn my-btn" [ngClass]="{'button-on': isColorPalleteVisible}" data-bs-toggle="tooltip" data-bs-placement="top" title="Change color" data-bs-delay="{show: 1000}">
            <i class="solar--pallete-2-outline" [ngStyle]="{'color': pickedColor}"></i>
          </button>
          <button class="btn my-btn" [ngClass]="{'button-on': isEraserEnabled}" (click)="switchEraser()" data-bs-toggle="tooltip" data-bs-placement="top" title="Eraser" data-bs-delay="{show: 1000}">
            <span class="mdi--eraser"></span>
          </button>
        </div>
        <div class="btn-group m-1">
          <button class="btn my-btn" (click)="addPostitCentrally(boxWidth, boxHeight*2, '', pickedColor)" data-bs-toggle="tooltip" data-bs-placement="top" title="Add note" data-bs-delay="{show: 1000}">
            <span class="mdi--note-outline"></span>
          </button>
          <button class="btn my-btn" (click)="addLabelCentrally(boxWidth, boxHeight*0.5, '', pickedColor)" data-bs-toggle="tooltip" data-bs-placement="top" title="Add label" data-bs-delay="{show: 1000}">
            <span class="iconoir--text"></span>
          </button>
          <button class="btn my-btn" (click)="showSearchPostPopup()" data-bs-toggle="tooltip" data-bs-placement="top" title="Add post from knowledge base">
            <span class="mdi--note-text-outline"></span>
          </button>
          <button class="btn my-btn" (click)="showSearchWorkpackagePopup()" data-bs-toggle="tooltip" data-bs-placement="top" title="Add task from project">
            <span class="mdi--list-box-outline"></span>
          </button>
          <button class="btn my-btn" (click)="openUploadDialog(20, 20, boxWidth, boxHeight * 2, true)" data-bs-toggle="tooltip" data-bs-placement="top" title="Add image">
            <span class="mdi--file-image-outline"></span>
          </button>
          <button class="btn my-btn" (click)="addFrame()" data-bs-toggle="tooltip" data-bs-placement="top" title="Add frame to group objects" data-bs-delay="{show: 1000}">
            <span class="material-symbols--screenshot-frame-2-rounded"></span>
          </button>
          <button class="btn my-btn" (click)="addUserStoryMap()" data-bs-toggle="tooltip" data-bs-placement="top" title="Add user story map" data-bs-delay="{show: 1000}">
            <span class="streamline--arrow-roadmap"></span>
          </button>
          <button class="btn my-btn" (click)="showPromptPopup()" data-bs-toggle="tooltip" data-bs-placement="top" title="Retrieve tasks and knowledge" data-bs-delay="{show: 1000}">
            <span class="mdi--alien-outline"></span>
          </button>
        </div>
      }
        @if (!isLaserPointerEnabled) {
        <button class="btn my-btn m-1" (click)="handleLaserPointer(true)" data-bs-toggle="tooltip" data-bs-placement="top" title="Laser pointer" data-bs-delay="{show: 1000}">
          <span class="mdi--laser-pointer"></span>
        </button>
        } @else {
        <button class="btn my-btn m-1 button-on" (click)="handleLaserPointer(false)" data-bs-toggle="tooltip" data-bs-placement="top" title="Laser pointer" data-bs-delay="{show: 1000}">
          <span class="mdi--laser-pointer"></span>
        </button>
        }
        @if (isProductlyMode == false) {
          <div class="btn-group m-1">
            @if (canvasHistory && canvasHistory.length > 0 && stepsToUndo > 0) {
            <button class="btn my-btn" (click)="undo()" data-bs-toggle="tooltip" data-bs-placement="top" title="Undo" data-bs-delay="{show: 1000}">
              <span class="mdi--undo-variant"></span>
            </button>
            }
            @if (undoedHistory && undoedHistory.length > 0) {
            <button class="btn my-btn" (click)="redo()" data-bs-toggle="tooltip" data-bs-placement="top" title="Redo" data-bs-delay="{show: 1000}">
              <span class="mdi--redo-variant"></span>
            </button>
            }
          </div>
        }

      @if (isDrawingStorymap == false) {
        <!--button class="btn my-btn m-1" (click)="generateStorymap()" data-bs-toggle="tooltip" data-bs-placement="top" title="Generate storymap based on project tasks" data-bs-delay="{show: 1000}">
          <span class="ri--mind-map"></span>
        </button-->
        }
        <div class="btn-group m-1">
          @if (tr.nodes().length > 0) {
            <button class="btn my-btn" (click)="handleDeleteOrBackspace()" data-bs-toggle="tooltip" data-bs-placement="top" title="Delete" data-bs-delay="{show: 1000}">
              <span class="mdi--delete-outline"></span>
            </button>
          }
          @if (isReadOnly == false && isProductlyMode == false) {
            <button class="btn my-btn" (click)="downloadCanvasHistory()" data-bs-toggle="tooltip" data-bs-placement="top" title="Download canvas history" data-bs-delay="{show: 1000}">
              <span class="mdi--briefcase-download-outline"></span>
            </button>
            <input type="file" #fileInput (change)="onFileSelected($event)" accept=".json" style="display:none"/>
            <button class="btn my-btn"  (click)="fileInput.click()" data-bs-toggle="tooltip" data-bs-placement="top" title="Upload canvas history" data-bs-delay="{show: 1000}">
              <span class="mdi--briefcase-upload-outline"></span>
            </button>
        }
        @if (isReadOnly == false) {
          <button class="btn my-btn" (click)="deleteAll()" data-bs-toggle="tooltip" data-bs-placement="top" title="Clean canvas" data-bs-delay="{show: 1000}">
            <span class="mdi--delete-alert-outline"></span>
          </button>
        }
        </div>
        <div class="btn-group m-1">
          <button class="btn my-btn" (click)="zoomIn(0.1)" data-bs-toggle="tooltip" data-bs-placement="top" title="Zoom in" data-bs-delay="{show: 1000}">
            <span class="ic--round-zoom-in"></span>
          </button>
          <button class="btn my-btn" (click)="zoomIn(-0.1)" data-bs-toggle="tooltip" data-bs-placement="top" title="Zoom out" data-bs-delay="{show: 1000}">
            <span class="ic--round-zoom-out"></span>
          </button>
        </div>
        <button class="btn my-btn m-1" [ngClass]="{'button-on': isMinimapVisible}" (click)="showMinimap()" data-bs-toggle="tooltip" data-bs-placement="top" title="Mini map" data-bs-delay="{show: 1000}">
          <span class="icon-park-outline--map-distance"></span>
        </button>
        <button class="btn my-btn m-1" (click)="shareCanvas()" data-bs-toggle="tooltip" data-bs-placement="top" title="Share canvas" data-bs-delay="{show: 1000}">
          <span class="mdi--share-variant-outline"></span>
        </button>
        <button class="btn my-btn m-1" (click)="downloadPDF()" data-bs-toggle="tooltip" data-bs-placement="top" title="Download canvas as PDF" data-bs-delay="{show: 1000}">
          <span class="carbon--document-pdf"></span>
        </button>
        @if (isProductlyMode == false) {
          <div class="btn-group m-1">
            <button class="btn my-btn" (click)="moveToPeriferalPosition('right')">
              <span class="iconamoon--arrow-right-2-thin"></span>
            </button>
            <button class="btn my-btn" (click)="moveToPeriferalPosition('bottom')">
              <span class="iconamoon--arrow-down-2-thin"></span>
            </button>
            <button class="btn my-btn" (click)="moveToPeriferalPosition('left')">
              <span class="iconamoon--arrow-left-2-thin"></span>
            </button>
            <button class="btn my-btn" (click)="moveToPeriferalPosition('top')">
              <span class="iconamoon--arrow-up-2-thin"></span>
            </button>
          </div>
          }
    </div>
  </div>
  </div>
  @if (addPostPopupVisible) {
    <app-postsearchpopup [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [userEmail]="userEmail" [userName]="userName" [canAddNewContent]="true" (foundContent)="onAddWorkpackageCentrally('content', $event)" (addNewPost)="onAddNewPost()"></app-postsearchpopup>
  }
  @if (addWorkpackagePopupVisible) {
    <app-workpackagesearchpopup [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [userEmail]="userEmail" [userName]="userName" [canAddNewContent]="true" (foundContent)="onAddWorkpackageCentrally('workpackage', $event)"></app-workpackagesearchpopup>
  }
  @if (isDrawingStorymap) {
    <div class="storymap-container">
      <div id="storymap-container">Drawing storymap, it may take a while...</div>
    </div>
  }
  @if (shareCanvasPopupVisible) {
    <div class="share-canvas-popup">
      <div class="share-canvas-popup-content">
        <h5>Share canvas</h5>
        <p>Canvas is shared with anonymous users. Copy link and share it with others:</p>
        <p (click)="copyCanvasLink()" class="share-canvas-link p-1">{{canvasLink}}</p>
        <button class="btn my-btn" (click)="copyCanvasLink()">
          <span class="mdi--content-copy"></span>
        </button>
      </div>
    </div>
  }
  @if(isPromptPopupVisible) {
    <div class="prompt-popup">
      <div class="close-button pointer right-corner" (click)="closePromptPopup()">
        <span class="mdi--close"></span>
      </div>
      <div class="prompt-popup-content">
        <h5>Find tasks and knowledge with AI</h5>
        <p class="prompt-popup-content-text">Enter a search query to retrieve tasks and knowledge. The more detailed the query, the more accurate the results.</p>
        <textarea type="text" [(ngModel)]="prompt" class="form-control" (keyup.enter)="searchContent()"></textarea>
        @if (promptFoundMessage == "") {
          <button class="btn my-btn my-2" (click)="searchContent()">
            <span class="mdi--alien-outline"></span>
          </button>
          <label class="mx-2 search-options">
            <input type="checkbox" [(ngModel)]="searchPosts"> Search Posts
          </label>
          <label class="mx-2 search-options">
            <input type="checkbox" [(ngModel)]="searchTasks"> Search Tasks
          </label>
          }
          <div class="found-message">
            {{promptFoundMessage}}
          </div>
          @if (isPromptPopupAddButtonVisible == true) {
          <button class="btn my-btn my-2" (click)="addPromptFoundContent()">
            <span class="mdi--add"></span>
          </button>
          }
      </div>
    </div>
  }
</div>
